{
  "title": "Attacks",
  "table": {
    "sid": "SID",
    "gid": "GID",
    "sensor_id": "dev ID",
    "time": "Time",
    "priority": "Priority",
    "proto": "Proto",
    "attacker_ip": "IP src",
    "attacker_port": "Port src",
    "host_ip": "IP dst",
    "host_port": "Port dst",
    "payload": "Payload"
  },
  "filter": {
    "datetime": "Datetime",
    "attacker_ip": "IP src",
    "host_ip": "IP dst",
    "priority": "Priority"
  }
}